<template>
    <div class="vx-card p-6">
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <h3>SMS chăm sóc khách hàng</h3>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-2/3 w-full">
                <div class="vx-row">
                    <!-- branch-->
                    <div class="vx-col w-full">
                        <label class="vs-input--label">Chi nhánh</label>
                        <v-select class="w-full" v-model="selectedOrganizationBranch"
                                  :options="organizationBranchOptions"
                                  :clearable="false" name="branch" v-validate="'required'">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                </div>

                <!--type-->
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Loại SMS gửi tin</label>
                        <v-select class="w-full" v-model="selectedType" :options="messageTypeOptions"
                                  :clearable="false"></v-select>
                    </div>
                </div>


                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">{{ this.$t('navMenu.smsBrandName') }}</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="selectTypeSms" :options="typeSms" :clearable="false" v-validate="'required'"
                                  name="typeForNewsEvent">
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('typeForNewsEvent') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Thời gian</label>
                        <datepicker :disabled="isUpdate" name="startDate" :format="'dd/MM/yyyy'"
                                    v-model="dataSms.sendTime"
                                    data-vv-validate-on="input" @input="dateSendSms"
                        ></datepicker>
                    </div>
                </div>
            </div>

        </div>

        <!--contentPost-->
        <div class="vx-row mt-2 mb-3">
            <div class="vx-col w-full mt-4">
                <label class="vs-input--label">{{ this.$t('navMenu.smsMessenger') }}</label>
                <vs-textarea
                    counter="255" label="Số ký tự tin nhắn: 255"
                    :counter-danger.sync="counterDanger"
                    id="textarea-state"
                    v-model="dataSms.message"
                    size="lg"
                    rows="3"
                    cols="5"
                />
            </div>
        </div>
        <br>
        <br>
        <!--buttons-->
        <div class="vx-row">
            <div class="vx-col w-full ">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2 button" :disabled="!validateForm" @click="saveInfoNewEvent"
                               v-if="(isUpdate && isPermissionUpdateNewsEvent) || (!isUpdate && isPermissionCreateNewsEvent)">
                        {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2 button" type="border" color="warning" onclick="history.back()">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../../components/utils";
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import {quillEditor} from 'vue-quill-editor'
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        Datepicker,
        utils,
        moment,
        quillEditor,
        VueUploadMultipleImage,
        authConfig,
    },
    data() {
        return {
            textarea: '',
            counterDanger: false,
            isUpdate: false,
            images: [],
            dataNewEvent: {
                title: null,
                content: null,
                type: null,
                organizationBranchId: null,
                activeStatus: null,
            },

            dataSms: {
                messageType: null,
                loyaltyCustomerIds: null,
                message: null,
                smsBrandNameId: null,
                organizationBranchId: null,
                sendTime: null,
                sendTimeStr: null,
                sendStatus: 0
            },

            messageTypeOptions: [
                {value: 1, label: 'Chăm sóc khách hàng'},
                {value: 2, label: 'Quảng cáo'},
            ],

            typeSms: [],

            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            selectNewsValue: null,
            turnOnOff: true,
            fileListData: [],
        }
    },
    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('menuOrganization.noBranch'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }

        this.organizationBranchOptions = branchList.map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });
        this.organizationBranchOptions.unshift({value: null, label: 'Tất cả'});
        await this.getListTypeSms();

        if (this.$route.query.id) {
            this.isUpdate = true;
            await this.findServiceById(this.$route.query.id);
            for (const x of this.dataSms) {
                let data = await this.toDataURL(x.url);
            }
        }
    },

    methods: {
        dateSendSms: function () {
            this.dataSms.sendTimeStr = this.dataSms.sendTime;
        },
        getListTypeSms() {
            return new Promise((resolve, reject) => {
                this.$crm.post('/sms-brand-name/get-all').then(res => {

                    for (const item of res.data) {
                        this.typeSms.push({value: item.id, label: item.brandName});
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    if (err.response.status === 401) {
                        localStorage.clear();
                        return this.$router.push("/pages/login");
                    }
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        async saveInfoNewEvent(evt) {
            //Validate data

            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.isUpdate) this.activeStatus = this.turnOnOff ? 1 : 0;

            // Xu ly du lieu formData
            this.dataSms.sendStatus = 0;
            if (!this.isUpdate){
                this.dataSms.sendTimeStr = moment(this.dataSms.sendTimeStr).format("yyyyMMDDHHmmss");
            }

            let request = this.dataSms;
            let url = this.isUpdate ? `/sms-message-config/update` : `/sms-message-config/create`;

            // Goi API
            this.$vs.loading();
            this.$crm.post(url, request).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuNewsEvent.updateNewEventNotify') : this.$t('menuNewsEvent.addNewEventNotify')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();
                return this.$router.push('/user/manage-care-sms').catch(() => {
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },


        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },

        findServiceById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/sms-message-config/find-by-id/${id}`).then(res => {
                    //this.turnOnOff = res.data.activeStatus !== 0;
                    this.dataSms = res.data;
                    this.dataSms.smsBrandNameId = res.data.smsBrandName.id;

                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },


        isPermissionCreateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_create);
        },

        isPermissionUpdateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_update);
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any();
        },
        selectedOrganizationBranch: {
            get() {
                let object = this.organizationBranchOptions.find(el => el.value === this.dataSms.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(obj) {
                this.dataSms.organizationBranchId = obj ? obj.value : null;
            }
        },

        selectTypeSms: {
            get() {

                let obj = this.typeSms.find(x => x.value === this.dataSms.smsBrandNameId);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.dataSms.smsBrandNameId = obj ? obj.value : null;
            }
        },

        selectedType: {
            get() {
                let obj = this.messageTypeOptions.find(x => x.value === this.dataSms.messageType);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.dataSms.messageType = obj ? obj.value : null;
            }
        },

    },
}
</script>
<style scoped>
@media (min-width: 320px) and (max-width: 399px) {
    .contentPost {
        margin-bottom: 125px;
        height: 200px;
    }

    .vs-input--label {
        justify-items: start !important;
        align-items: start !important;
        margin-top: 20px;
    }

    .button {
        margin-top: 10px !important;
    }
}

@media (min-width: 400px) and (max-width: 411px) {
    .contentPost {
        margin-bottom: 120px;
        height: 300px;
    }

    .vs-input--label {
        margin-top: 20px;
    }

    .button {
        margin-top: 10px !important;
    }

}

@media (min-width: 412px) and (max-width: 767px) {
    .contentPost {
        margin-bottom: 80px;
        height: 300px;
    }

    .vs-input--label {
        margin-top: 20px;
    }

    .button {
        margin-top: 20px !important;
    }
}

@media (min-width: 768px) {
    .vs-input--label {
        text-align: center !important;
    }

    .contentPost {
        height: 500px;

    }

    button {
        margin-top: 30px !important;
    }
}
</style>
